document.addEventListener('DOMContentLoaded', () => {

    const sections = document.querySelectorAll('.brand-group');
    const links = document.querySelectorAll('.brands-alphabet a');

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (!entry.isIntersecting) return;

            links.forEach((link) => link.classList.remove('active'));

            const active = document.querySelector(
                `.brands-alphabet a[href="#${entry.target.id}"]`
            );

            if (active) {
                active.classList.add('active');
            }

        });

    }, {
        rootMargin: '0% 0px -85% 0px'
    });

    sections.forEach((section) => observer.observe(section));

});